const AREAS = [
  {
    state: "New York",
    icon: "ri-map-pin-2-fill",
    locations: [
      "Long Island (Nassau & Suffolk Counties)",
      "Queens",
      "The Bronx",
      "Manhattan",
      "Staten Island",
      "Westchester County",
      "Rockland County",
      "Brooklyn",
    ],
  },
  {
    state: "New Jersey",
    icon: "ri-map-pin-2-fill",
    locations: [
      "Bergen County",
      "Essex County",
      "Hudson County",
      "Union County",
      "Passaic County",
      "Middlesex County",
      "Morris County",
      "Monmouth County",
    ],
  },
  {
    state: "Connecticut",
    icon: "ri-map-pin-2-fill",
    locations: [
      "Fairfield County",
      "Greenwich",
      "Stamford",
      "Darien",
      "Norwalk",
      "Bridgeport",
      "New Haven County",
      "Westport",
    ],
  },
];

export default function ServiceAreas() {
  return (
    <section className="bg-brand-dark py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="font-sans text-xs tracking-widest uppercase text-brand-gold mb-4 flex items-center justify-center gap-3">
            <span className="w-8 h-px bg-brand-gold" />
            Coverage Area
            <span className="w-8 h-px bg-brand-gold" />
          </p>
          <h2 className="font-serif text-4xl lg:text-5xl font-semibold text-brand-white leading-tight mb-4">
            Pre-Purchase Inspections Across the Tri-State Area
          </h2>
          <p className="font-sans text-base text-brand-gray max-w-2xl mx-auto">
            We travel to the seller&apos;s location — wherever the car is. Our mobile inspection service covers the entire NY, NJ, and CT metro region. Out-of-state buyers welcome.
          </p>
        </div>

        {/* Map placeholder + state columns */}
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 items-start">
          {/* Map embed */}
          <div className="lg:col-span-1 rounded-2xl overflow-hidden border border-brand-gold/15 h-64 lg:h-full min-h-[300px]">
            <iframe
              title="Lemon Protector Service Area Map — NY NJ CT"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1513127.5037895263!2d-74.72168!3d40.9!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24fa5d33f083b%3A0xc80b8f06e177fe62!2sNew%20York%2C%20NY!5e0!3m2!1sen!2sus!4v1710000000000"
              className="w-full h-full border-0 grayscale"
              loading="lazy"
              allowFullScreen
            />
          </div>

          {/* State columns */}
          {AREAS.map((area) => (
            <div
              key={area.state}
              className="bg-brand-charcoal border border-brand-gold/10 rounded-2xl p-7 hover:border-brand-gold/30 transition-colors"
            >
              <div className="flex items-center gap-3 mb-5">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className={`${area.icon} text-brand-gold text-xl`} />
                </div>
                <h3 className="font-serif text-xl font-semibold text-brand-white">{area.state}</h3>
              </div>
              <ul className="flex flex-col gap-2.5">
                {area.locations.map((loc) => (
                  <li key={loc} className="flex items-center gap-3 font-sans text-sm text-brand-gray-light">
                    <span className="w-1.5 h-1.5 rounded-full bg-brand-gold/60 shrink-0" />
                    {loc}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom note */}
        <div className="mt-10 text-center">
          <p className="font-sans text-sm text-brand-gray">
            Area not listed?{" "}
            <a href="tel:5169833800" className="text-brand-gold hover:text-brand-gold-light transition-colors font-semibold cursor-pointer">
              Call (516) 983-3800
            </a>{" "}
            or{" "}
            <a href="tel:7182297594" className="text-brand-gold hover:text-brand-gold-light transition-colors font-semibold cursor-pointer">
              (718) 229-7594
            </a>{" "}
            — we&apos;ll confirm if we service your location.
          </p>
          <p className="font-sans text-xs text-brand-gray mt-2">
            Out-of-state buyers purchasing vehicles in NY, NJ, or CT are also welcome.
          </p>
        </div>
      </div>
    </section>
  );
}
